import {
  Box,
  CircularProgress
} from "@material-ui/core";
import React, { useContext, useState, useEffect } from "react";
import {Context} from './../../../GlobalStates';

import './../styles/LoginContentDialog.css';

import { ReactComponent as IconClose } from './../assets/Icon_X.svg';
import { ReactComponent as IconBack } from './../assets/Icon_Back.svg';

import { ValidateEmail } from './../helpers/Validation.js';
import { ValidatePasswordResetCode } from './../helpers/Validation.js';
import { ValidatePassword } from './../helpers/Validation.js';

/**
 * Dialog for the globalStates.loginDialogArr: LoginContentDialog__PWReset__ChangePW
 *
 * Expected globalStates.loginDialogArr[0] param:
 * @param dialog: "LoginContentDialog__PWReset__ChangePW"
 * @param email: "email"
 * @param code: "code"
 * @since 2021.10.10
 */
function LoginContentDialog__PWReset__ChangePW () {

  //GlobalStates
  const [globalStates, dispatch] = useContext(Context);

  const axios = require('axios').default;

  const [fetchApiData, setFetchApiData] = useState(null); // null|"rdy to start"|"finished"
  const [enteredEmail, setEnteredEmail] = useState(globalStates.loginDialogArr[0].email);
  const [enteredCode, setEnteredCode] = useState(globalStates.loginDialogArr[0].code);
  const [enteredPassword, setEnteredPassword] = useState("");
  const [enteredPasswordConf, setEnteredPasswordConf] = useState("");


  // important, this LoginContentDialog__PWReset__ChangePW.js file is only allowed to be included once, cuz we use here useEffect()
  useEffect(() => {
    async function fetchAPI(user_email, entered_code, entered_password) {
      console.log("fetchAPI | user_email[" + user_email + "] entered_code[" + entered_code + "] entered_password[" + entered_password + "]");
      const newPost = {
        request: "password_reset",
        user_email: user_email,
        password_reset_code: entered_code,
        new_password: entered_password
      }

      let resp = "";
      try {
          resp = await axios.post(globalStates.url_api_account, newPost);
          //console.log(resp);
          //console.log("LoginContentDialog__PWReset__ChangePW.js | API response | resp.response[" + resp.data.response + "]");
          switch(resp.data.response) {
            case "password_reset_success":
              // see finally
              dispatch({type: 'SET_NEW_SNACKBAR', payload: { status: "red", message: "Password successfully changed. Please login." }});
              break;
            case "password_reset_wrong_email":
              dispatch({type: 'SET_NEW_SNACKBAR', payload: { status: "red", message: "Sorry, couldn't find that email." }});
              break;
            case "password_reset_wrong_code":
              dispatch({type: 'SET_NEW_SNACKBAR', payload: { status: "red", message: "Wrong code. Please take the code from the last received email. (Also check spam folder)" }});
              break;
            case "blocked_user":
              dispatch({type: 'SET_NEW_SNACKBAR', payload: { status: "red", message: "Sorry to bother you but there is a technical issue with your email account. Please get in touch with Marcel to fix it." }});
              break;
            case "blocked_user_password_reset_code_retries_exceeded":
              dispatch({type: 'SET_NEW_SNACKBAR', payload: { status: "red", message: "For security reasons is your account currently not reachable. Please get in touch with Marcel to fix it." }});
              break;
            case "password_syntax_not_supported":
              dispatch({type: 'SET_NEW_SNACKBAR', payload: { status: "red", message: "Invalid password syntax. Allowed syntax: a-zA-Z0-9!@#$%^&*" }});
              break;
            case "server_error":
              dispatch({type: 'SET_NEW_SNACKBAR', payload: { status: "red", message: "Server error. If this error consists please let Marcel know." }});
              break;
            case "server_maintenance":
              dispatch({type: 'SET_NEW_SNACKBAR', payload: { status: "red", message: "Server are currently under maintenance (this error should not happen). If this error consists please let Marcel know." }});
              break;
            default:
              dispatch({type: 'SET_NEW_SNACKBAR', payload: { status: "red", message: "Unexpected api response. If this error consists please let Marcel know." }});
          }
      } catch (err) {
          console.error(err);
          dispatch({type: 'SET_NEW_SNACKBAR', payload: { status: "red", message: "Unexpected error. If this error consists please let Marcel know." }});
      } finally {
          setFetchApiData("finished"); // todo maybe also reset?
          if (resp.data.response === "password_reset_success") {
            dispatch({type: 'LOGINDIALOGARR_REPLACE', payload: [ { dialog: "LoginContentDialog__Login", email: enteredEmail } ] }); // must be the last operation -> otherwise error
          }
      }
    }

    if (fetchApiData === "rdy to start") {

      if (ValidateEmail(enteredEmail)) {
        if (ValidatePasswordResetCode(enteredCode)) {
          if ((enteredPassword === enteredPasswordConf) && ValidatePassword(enteredPassword)) {
            // start getting new keywords -async approach
            // valid email & code & password syntax
            console.log("LoginContentDialog__PWReset__ChangePW.js | starting fetchApiData | enteredEmail[" + enteredEmail + "] enteredCode[" + enteredCode + "]");
            fetchAPI(enteredEmail, enteredCode, enteredPassword);
          } else {
            setFetchApiData(null);
            if (enteredPassword !== enteredPasswordConf) {
              setEnteredPassword("");
              setEnteredPasswordConf("");
              dispatch({type: 'SET_NEW_SNACKBAR', payload: { status: "red", message: "Entered passwords were not equal. Please try again." }});
            } else if ((enteredPassword.length < 8) || (enteredPassword > 18)) {
              dispatch({type: 'SET_NEW_SNACKBAR', payload: { status: "red", message: "The password length needs to be between 8 and 18 characters." }});
            } else {
              dispatch({type: 'SET_NEW_SNACKBAR', payload: { status: "red", message: "Invalid password syntax. Allowed syntax: a-zA-Z0-9!@#$%^&*" }});
            }
          }
        } else {
          setFetchApiData(null);
          dispatch({type: 'SET_NEW_SNACKBAR', payload: { status: "red", message: "Wrong code - please try again." }});
        }
      } else {
        setFetchApiData(null);
        dispatch({type: 'SET_NEW_SNACKBAR', payload: { status: "red", message: "Please check your email again. (Invalid syntax)" }});
      }

    } else if (fetchApiData === "finished") {
      // finished the new keyword search
    }

  }, [fetchApiData])


  const handleLoginOnKeyDownEmail = (event) => {
    setEnteredEmail(event.target.value.trim());
    if (event.key === 'Enter') {
      setFetchApiData("rdy to start") // starting getting the api data
    }
  }

  const handleLoginOnKeyDownCode = (event) => {
    setEnteredCode(event.target.value.trim());
    if (event.key === 'Enter') {
      setFetchApiData("rdy to start") // starting getting the api data
    }
  }

  const handleLoginOnKeyDownPassword = (event) => {
    setEnteredPassword(event.target.value.trim());
    if (event.key === 'Enter') {
      setFetchApiData("rdy to start") // starting getting the api data
    }
  }

  const handleLoginOnKeyDownPasswordConfirm = (event) => {
    setEnteredPasswordConf(event.target.value.trim());
    if (event.key === 'Enter') {
      setFetchApiData("rdy to start") // starting getting the api data
    }
  }

  const handleOnClickHeaderBack = () => {
    dispatch({type: 'LOGINDIALOGARR_REMOVE_FIRST'});
  }

  const handleOnClickHeaderClose = () => {
    dispatch({type: 'LOGINDIALOGARR_REMOVE_ALL'});
  }

  const handleOnClickLoginBtn = (event) => {
    setFetchApiData("rdy to start") // starting getting the api data
  }

  return (
    <>
      <Box className="LoginContentDialog">
        <Box className="LoginContentDialog__Header">
          <IconBack className="LoginContentDialog__HeaderIconBack" fill="white" onClick={handleOnClickHeaderBack}/>
          <IconClose className="LoginContentDialog__HeaderIconClose" fill="white" onClick={handleOnClickHeaderClose}/>
          <span className="LoginContentDialog__HeaderText">Password Reset</span>
        </Box>
        <Box className="LoginContentDialog__Content">
          <input autoComplete="off" type="email" name="emailInput" placeholder="Email..." value={enteredEmail} className="LoginContentDialog__Input LoginContentDialog__Input--Fixed LoginContentDialog__Input--NoMarginRight" disabled="disabled" onChange={handleLoginOnKeyDownEmail} onKeyDown={handleLoginOnKeyDownEmail}/>
          <input autoComplete="off" type="text" name="codeInput" placeholder="123456" value={enteredCode} className="LoginContentDialog__Input LoginContentDialog__Input--Fixed LoginContentDialog__Input--NoMarginRight" disabled="disabled" onChange={handleLoginOnKeyDownCode} onKeyDown={handleLoginOnKeyDownCode}/>
          <input autoComplete="off" type="password" name="passwordInput" placeholder={"New Password..."} value={enteredPassword} className="LoginContentDialog__Input LoginContentDialog__Input--NoMarginRight" onChange={handleLoginOnKeyDownPassword} onKeyDown={handleLoginOnKeyDownPassword}/>
          <input autoComplete="off" type="password" name="passwordConfirmInput" placeholder={"Confirm New Password..."} value={enteredPasswordConf} className="LoginContentDialog__Input LoginContentDialog__Input--NoMarginRight" onChange={handleLoginOnKeyDownPasswordConfirm} onKeyDown={handleLoginOnKeyDownPasswordConfirm}/>
          <Box className="LoginContentDialog__Input LoginContentDialog__Btn" onClick={handleOnClickLoginBtn}>
            { (fetchApiData === "rdy to start")
              ? ( <CircularProgress className="LoginContentDialog__BtnSpinner"/> )
              : ( <>CONFIRM CODE</> )
            }
          </Box>
        </Box>
      </Box>
    </>
  )

};

export default LoginContentDialog__PWReset__ChangePW;